import axios, { getFormDataHeaders } from "./config";
export default {
    store: function(transition) {
        return axios.post("/transitions", transition, {
            headers: getFormDataHeaders(),
        });
    },
};